interface Option {
	label: string;
}

export const getSelectedOptions = (
	container: Option[],
	keys: string[] | undefined
) => {
	if (!container.length || typeof keys === 'undefined' || !keys.length) {
		return [] as Option[];
	}

	const selectedKeys: Option[] = [];

	container.forEach((item) => {
		if (keys.includes(item.label)) {
			selectedKeys.push(item);
		}
	});

	return selectedKeys;
};
